var _path, _path2, _path3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCodRemittance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 57,
    viewBox: "0 0 53 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M34.6356 6.72656V22.0939C34.7215 22.7185 34.6661 23.3552 34.4737 23.9537C34.2813 24.5523 33.9573 25.0961 33.5272 25.5422C33.0971 25.9883 32.5728 26.3245 31.9958 26.524C31.4189 26.7236 30.805 26.7811 30.2029 26.692H12.472C11.8699 26.7811 11.256 26.7236 10.6791 26.524C10.1021 26.3245 9.57778 25.9883 9.14771 25.5422C8.71764 25.0961 8.39358 24.5523 8.20119 23.9537C8.00881 23.3552 7.95338 22.7185 8.03929 22.0939V6.72656H34.6356Z",
    fill: "url(#paint0_linear_245_93690)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6356 4.07296V6.72634H8.03929V4.07296C7.95338 3.53233 8.00881 2.98116 8.20119 2.4631C8.39358 1.94503 8.71764 1.47428 9.14771 1.08813C9.57778 0.701971 10.1021 0.411007 10.6791 0.238267C11.256 0.0655271 11.8699 0.0157557 12.472 0.0928919H30.2029C30.805 0.0157557 31.4189 0.0655271 31.9958 0.238267C32.5728 0.411007 33.0971 0.701971 33.5272 1.08813C33.9573 1.47428 34.2813 1.94503 34.4737 2.4631C34.6661 2.98116 34.7215 3.53233 34.6356 4.07296Z",
    fill: "#AD00FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.403 22.7307H13.6015C13.177 22.7307 12.7699 22.5199 12.4698 22.1448C12.1696 21.7696 12.001 21.2607 12.001 20.7301C12.001 20.1995 12.1696 19.6906 12.4698 19.3155C12.7699 18.9403 13.177 18.7295 13.6015 18.7295H18.403C18.8274 18.7295 19.2345 18.9403 19.5347 19.3155C19.8348 19.6906 20.0034 20.1995 20.0034 20.7301C20.0034 21.2607 19.8348 21.7696 19.5347 22.1448C19.2345 22.5199 18.8274 22.7307 18.403 22.7307Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_245_93690)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_245_93690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.5571 40.9414C46.4949 40.9414 52.9297 34.5066 52.9297 26.5688C52.9297 18.6311 46.4949 12.1963 38.5571 12.1963C30.6194 12.1963 24.1846 18.6311 24.1846 26.5688C24.1846 34.5066 30.6194 40.9414 38.5571 40.9414Z",
    fill: "#FF1DCD",
    fillOpacity: 0.07
  })), /*#__PURE__*/React.createElement("path", {
    d: "M42.8287 29.4678C42.8286 28.6272 42.5477 27.8108 42.0305 27.1481C41.5134 26.4854 40.7897 26.0144 39.9743 25.81L37.6632 25.2351C37.3103 25.1469 36.9977 24.9417 36.7764 24.653C36.5569 24.372 36.4389 24.0251 36.4415 23.6685C36.4423 23.2412 36.6125 22.8316 36.9148 22.5296C37.217 22.2276 37.6268 22.0577 38.0541 22.0574H39.0602C39.4574 22.0581 39.8405 22.205 40.1363 22.4701C40.4321 22.7352 40.62 23.0999 40.6642 23.4946C40.6759 23.6384 40.7165 23.7784 40.7833 23.9062C40.8502 24.034 40.942 24.1472 41.0534 24.2389C41.1648 24.3305 41.2934 24.3989 41.4318 24.44C41.5701 24.4811 41.7152 24.4939 41.8586 24.4779C42.0019 24.4618 42.1406 24.4171 42.2664 24.3465C42.3922 24.2758 42.5025 24.1806 42.5908 24.0665C42.6792 23.9525 42.7437 23.8218 42.7806 23.6824C42.8175 23.5429 42.826 23.3974 42.8057 23.2546C42.7133 22.4268 42.3487 21.6531 41.7692 21.0548C41.1896 20.4566 40.4279 20.0676 39.6035 19.9489V19.3826C39.6035 19.0967 39.4899 18.8226 39.2877 18.6204C39.0856 18.4183 38.8114 18.3047 38.5255 18.3047C38.2396 18.3047 37.9655 18.4183 37.7633 18.6204C37.5612 18.8226 37.4476 19.0967 37.4476 19.3826V19.9575C36.5926 20.0966 35.8118 20.5265 35.237 21.1745C34.6621 21.8225 34.3285 22.649 34.2923 23.5144C34.2562 24.3799 34.5198 25.2313 35.0386 25.925C35.5574 26.6187 36.2996 27.1121 37.14 27.322L39.4511 27.8969C39.8326 27.993 40.1659 28.2251 40.3883 28.5496C40.6107 28.8741 40.707 29.2686 40.6589 29.6591C40.6109 30.0496 40.422 30.409 40.1276 30.67C39.8332 30.9309 39.4536 31.0754 39.0602 31.0761H38.0541C37.6569 31.0754 37.2738 30.9285 36.978 30.6634C36.6822 30.3983 36.4943 30.0336 36.4501 29.6389C36.4384 29.4951 36.3978 29.3551 36.331 29.2273C36.2641 29.0995 36.1723 28.9863 36.0609 28.8946C35.9495 28.8029 35.8208 28.7345 35.6825 28.6935C35.5442 28.6524 35.3991 28.6396 35.2557 28.6556C35.1123 28.6717 34.9737 28.7164 34.8479 28.787C34.7221 28.8577 34.6118 28.9529 34.5234 29.067C34.4351 29.181 34.3706 29.3117 34.3337 29.4511C34.2968 29.5906 34.2883 29.7361 34.3086 29.8789C34.3992 30.6966 34.7551 31.4621 35.322 32.0583C35.8889 32.6546 36.6355 33.0486 37.4476 33.1803V33.7552C37.4476 34.0411 37.5612 34.3152 37.7633 34.5174C37.9655 34.7196 38.2396 34.8331 38.5255 34.8331C38.8114 34.8331 39.0856 34.7196 39.2877 34.5174C39.4899 34.3152 39.6035 34.0411 39.6035 33.7552V33.1803C40.4987 33.0541 41.3182 32.6086 41.9109 31.9258C42.5036 31.2431 42.8295 30.3691 42.8287 29.465V29.4678Z",
    fill: "#AD00FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_245_93690",
    x: 0.0945702,
    y: 3.50629,
    width: 52.8351,
    height: 52.7251,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -12.1,
    dy: 3.3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.995
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.65 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_245_93690"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_245_93690",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_245_93690",
    x: 6.58457,
    y: -5.40371,
    width: 63.9451,
    height: 63.9451,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 8.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_245_93690"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_245_93690",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_245_93690",
    x1: 21.3374,
    y1: -27.4131,
    x2: 22.1952,
    y2: 33.7169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF00A8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodRemittance);
export default __webpack_public_path__ + "static/media/CODRemittance.7274a1ea1e096ccef27847785936a77e.svg";
export { ForwardRef as ReactComponent };